var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.222 275C488.223 227.875 460.724 123.25 436.101 88.25C397.603 33.625 334.481 0 266.11 0H191.989C85.995 0 0 86 0 192C0 248.75 24.749 299.625 63.996 334.875V512H319.982V448H383.979C419.352 448 447.975 419.375 447.975 384V320H479.973C503.097 320 518.596 296.125 509.222 275ZM352.002 224C334.378 224 320.004 209.625 320.004 192S334.378 160 352.002 160S384 174.375 384 192S369.626 224 352.002 224Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSide);
export default __webpack_public_path__ + "static/media/head-side.61bf253fecdaf4431f8a6bdab56a3c27.svg";
export { ForwardRef as ReactComponent };